export const addScrollToTop = (originalFunction) => () => {
  originalFunction()
  window.scrollTo(0, 0)
}
